export default {
    title: 'ผลคาบเรียน',

    sessionInfo: {
        title: 'ข้อมูลพื้นฐาน',
        items: {
            date: 'วันที่{mode}',
            duration: 'ระยะเวลาที่ใช้',
            studentCount: 'ผู้เข้าร่วม',
        },
        durationFormat: '{startTime} ~ {endTime} ({duration} นาที)',
    },
    curriculumInfo: {
        title: 'ชื่อคาบเรียน',
        selfModeTitle: 'ชื่อการเรียนด้วยตนเอง',
        taskModeTitle: 'ชื่อการบ้าน',
    },

    summary: {
        title: 'ข้อมูลกิจกรรม',
        completedActivity: 'กิจกรรมที่ทำ',
        headers: {
            activity: 'กิจกรรม',
            achievement: 'ผลสัมฤทธิ์',
        },
    },

    studentResults: {
        title: 'จำนวนคำตอบถูกของแต่ละคนและ MVP',
        mvp: 'MVP',
        headers: {
            student: 'นักเรียน',
            answers: 'จำนวนคำตอบถูก',
            score: 'คะแนน',
        },
    },

    actions: {
        close: 'ปิดหน้าต่าง',
        print: 'พิมพ์',
        export: 'ส่งออก',
    },

    errors: {
        windowClose: 'เกิดข้อผิดพลาด กรุณาปิดหน้าต่างด้วยตนเอง',
    },
};
